<h2 mat-dialog-title class="text-lg font-bold mb-1">  {{ isEditMode ? 'Editar Registro' : 'Nuevo Registro' }}</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">

    <mat-form-field appearance="fill" class="col-span-1">
        <mat-label>Nombre(s)</mat-label>
        <input
          matInput
          [(ngModel)]="currentCreateBusinessPartnerContact.contact.firstName"
          name="firstName"
          (ngModelChange)="updateFullName()"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="fill" class="col-span-1">
        <mat-label>Apellido(s)</mat-label>
        <input
          matInput
          [(ngModel)]="currentCreateBusinessPartnerContact.contact.lastName"
          name="lastName"
          (ngModelChange)="updateFullName()"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="fill" class="col-span-2">
        <mat-label>Nombre Completo</mat-label>
        <input
          matInput
          [value]="currentCreateBusinessPartnerContact.contact.fullName"
          name="fullName"
          readonly
          required
        />
      </mat-form-field>
      <div class="col-span-2">
        <label>Función de Contacto</label>
        <ng-select
          [(ngModel)]="currentCreateBusinessPartnerContact.contact.functionId"
          [items]="functionList"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          placeholder="Seleccione una función de contacto"
          name="functionId"
          [appendTo]="'body'"
        >
        </ng-select>
      </div>
      <!-- ng-select for compania -->
      <div class="col-span-1">
        <label>Compañía</label>
        <ng-select
          [(ngModel)]="currentCreateBusinessPartnerContact.companyId"
          [items]="companyList"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          placeholder="Seleccione Compañía"
          name="companyId"
          [appendTo]="'body'"
          required
        >
        </ng-select>
      </div>

      <!-- ng-select for sales-organization -->
      <div class="col-span-1">
        <label>Oficina de Venta</label>
        <ng-select
          [(ngModel)]="currentCreateBusinessPartnerContact.routingSalesOfficeId"
          [items]="salesOfficeList"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          placeholder="Seleccione una oficina de venta"
          name="routingSalesOfficeId"
          [appendTo]="'body'"
        >
        </ng-select>
      </div>
      <div class="col-span-1">
        <label>Área de Ruta</label>
        <ng-select
          [(ngModel)]="currentCreateBusinessPartnerContact.routeAreaId"
          [items]="routeAreaList"
          bindLabel="name"
          bindValue="_id"
          [searchable]="true"
          placeholder="Seleccione una ruta"
          name="routeAreaId"
          [appendTo]="'body'"
        >
        </ng-select>
      </div>
        <!-- ng-select for Compañía -->
        <!-- <div class="col-span-1">
          <label for="group-select">SubRutas</label>
          <ng-select
            [(ngModel)]="currentCreateBusinessPartnerContact.subRouteIds"
            [items]="subRutaList"
            bindLabel="name"
            bindValue="_id"
            [searchable]="true"
            [multiple]="true"
            placeholder="Seleccione subrutas"
            name="subRouteIds"
           [appendTo]="'body'"
            required
          >
          </ng-select>
        </div> -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label for="group-select">Rutas</mat-label>
          <mat-select
            [formControl]="routeMultiCtrl"
            placeholder="Seleccione rutas"
            [multiple]="true"
          >
            <mat-option>
              <ngx-mat-select-search
                [showToggleAllCheckbox]="true"
                [toggleAllCheckboxIndeterminate]="isIndeterminate"
                [toggleAllCheckboxChecked]="isChecked"
                (toggleAll)="toggleSelectAll($event)"
                [formControl]="routeMultiFilterCtrl"
                [noEntriesFoundLabel]="'No se encontraron resultados'"
                [placeholderLabel]="'Buscar ruta...'"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let route of filteredRoutes | async"
              [value]="route"
            >
              <b>{{ route?.externalKeys?.code }}</b
              >-{{ route.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="col-span-1 flex items-center">
            <span class="slide">¿Contacto Principal?</span>
            <mat-slide-toggle
              [(ngModel)]="currentCreateBusinessPartnerContact.contact.isPrincipal"
              name="isPrincipal"
              color="primary"
            >
            </mat-slide-toggle>
          </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
  {{ isEditMode ? 'Actualizar' : 'Guardar' }}
  </button>
</mat-dialog-actions>
